import { useQuery, useMutation, useQueryClient } from "@tanstack/react-query";
import { toast } from "react-toastify";
import { changePassword, forgotPassword, getProfile, login, logout, resetPassword } from "./AuthRepository";
import { Navigate, useNavigate } from "react-router-dom";


// Login hook
export const useLogin = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: login,
    onSuccess: (data) => {
      localStorage.setItem("Apptoken", data.data.AppToken);
      localStorage.setItem("User", JSON.stringify(data.data.employee));
      queryClient.setQueryData(["USER"], data);
      // toast.success("Login successful!");
    },
  });
};

// Fetch user data hook
export const useProfileData = ({
  enable = false,
}: { enable?: boolean } = {}) => {
  return useQuery({
    queryKey: ["USER_PROFILE"],
    queryFn: getProfile,
    enabled: enable,
    retry: false,
  });
};

// Logout hook
export const useLogout = () => {
  const queryClient = useQueryClient();
  const navigate = useNavigate();

  return useMutation({
    mutationFn: logout,
    onSuccess: (data) => {
      // ✅ Clear local storage
      localStorage.removeItem('Apptoken');
      localStorage.removeItem('Profile');
      localStorage.removeItem('User');
      toast.success(`${data.message}`);
      // ✅ Clear React Query cache
      queryClient.clear();
      // ✅ Redirect to login page
      window.location.href = `${process.env.PUBLIC_URL || ""}/login`;
      // navigate("/login");
    },
    onError: (error) => {
      console.error("Logout failed:", error);
      toast.error("Logout failed. Please try again.");
    },
  });
};



  export const useForgot = () => {
    const queryClient = useQueryClient();
    const navigate = useNavigate();
  
    return useMutation({
      mutationFn: forgotPassword,
      onSuccess: (data) => {
        toast.success(data.message);
        navigate('/resetPassword');
      },
      
    });
  };

  export const usePasswordReset = () => {
    const queryClient = useQueryClient();
    const navigate = useNavigate();
  
    return useMutation({
      mutationFn: (body: { otp: string; new_password: string; confirm_password: string  }) => 
        resetPassword(body),
      onSuccess: (data) => {
        toast.success(data.message);
        navigate('/login');
      },
      
    });
  }

export const useChangePassword = () => {

  return useMutation({
    mutationFn: (body: {
      old_password: string;
      new_password: string;
      confirm_password: string;
    }) => changePassword(body),
    onSuccess: (data) => {
      console.log("change_password", data);
      toast.success(data.message);
      // navigate('/login')
    },
  });
};
